<script setup lang="ts">
import { MtdButton, MtdTypography } from '@paygine/mtd-uikit'
import { storeToRefs } from 'pinia'
import { ref, useTemplateRef } from 'vue'

import type { Steps } from '@/shared/constants'

import { userDataModel } from '@/entities/user-data'
import { useModel } from '@/pages/tollroads_enroll_page/model'
import { VOtp, VTimer } from '@/shared/ui'

const emit = defineEmits<{
    goto: [Steps]
}>()

const store = userDataModel.useModel()
const { fetchUserData, r$ } = store
const { isFetchingData, userData } = storeToRefs(store)

const { isLoading, login, secondsBetweenRequest, sendOtp } = useModel()

const isTimerVisible = ref(true)
const timerRef = useTemplateRef<null | typeof VTimer>('timerRef')

const otpStatus = ref<'error' | 'loading' | 'success'>()
const otpRef = useTemplateRef('otp-ref')

function handleOtpChange() {
    otpStatus.value = undefined
}

async function onSubmit(code: string) {
    otpStatus.value = 'loading'

    const result = await login(code)
    otpStatus.value = result ? 'success' : 'error'
    if (!result) return

    await fetchUserData()

    if (!userData.value?.grn_list?.length) {
        emit('goto', 'addCar')
        return
    }

    if (!userData.value?.payment_methods?.sbp?.length) {
        emit('goto', 'select-pay-method')
        return
    }

    emit('goto', 'sub_management')
}

async function resendCode() {
    if (await sendOtp()) {
        otpRef.value?.reset()
        isTimerVisible.value = true
    }
}
</script>
<template>
    <MtdTypography
        variant="header-2"
        class="default-layout__title"
        tag="h1"
        >Введите код из СМС
    </MtdTypography>

    <MtdTypography
        tag="p"
        variant="body-2"
        class="default-layout__subtitle"
        >Отправили на {{ r$.phone.$value }}</MtdTypography
    >

    <VOtp
        ref="otp-ref"
        class="mt-24"
        :status="otpStatus"
        @submit="onSubmit"
        @change="handleOtpChange"
    />

    <MtdButton
        type="button"
        class="mt-32"
        :disabled="isTimerVisible"
        :is-loading="isLoading || isFetchingData"
        @click="resendCode"
        >Отправить код ещё раз

        <VTimer
            v-if="isTimerVisible"
            ref="timerRef"
            :seconds="secondsBetweenRequest"
            @time:end="isTimerVisible = false"
        />
    </MtdButton>
    <MtdButton
        variant="main-secondary"
        class="mt-12"
        :is-loading="isFetchingData"
        @click="emit('goto', 'auth')"
        >Изменить телефон</MtdButton
    >
</template>
